import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { PyodideBridge } from './bridge-client';
import { BrowserPlatformAdapter } from './platform';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode><App bridge={new PyodideBridge()} platform={new BrowserPlatformAdapter()} /></StrictMode>,
);
